import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { directPatient, directPatientData } from '../../../interfaces/patient-services/directpatient';
import { directPatientBillingApi } from '../api/directpatient.api';

@Injectable() 
export class directPatientBillingService extends directPatientData{
 
  constructor(private api: directPatientBillingApi) {
    super();
  } 
  
  getall(url: string): Observable<any[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<any>{
      return this.api.getby_id(url);
  }

  create(url: string, data:any): Observable<any[]> {
    return this.api.add(url,data);
  }

  getData(url: string, data:any): Observable<any[]> {
    return this.api.getData(url,data);
  }

  update(url: string, data:any): Observable<any> { 
    return this.api.update(url,data);
  }  

  cancelBill(url: string,data): Observable<any> {
    return this.api.cancelBill(url, data);
  }

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
